export function setCookie(c_name, value, expire) {
  let date = new Date();
  // date.setSeconds(date.getSeconds() + expire);
  date.setTime(date.getTime() + expire * (24 * 60 * 60 * 1000));
  document.cookie = c_name + "=" + encodeURIComponent(value) + "; expires=" + date.toUTCString()
  // console.log(document.cookie)
}

export function getCookie(c_name) {
  if (document.cookie.length > 0) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [name, ...rest] = cookie.split("=");
      if (name.trim() === c_name) {
        const value = rest.join("=");
        return decodeURIComponent(value);
      }
    }
  }
  return "";
}
